import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

import { userActions } from '@/redux/actions';
import { useAppDispatch } from '@/redux/hooks';

import { COMMON_CONTAINER_ID, TELEGRAM_OAUTH_OPTIONS } from '@/config';
import { Button, SvgIcon } from '@/components';

import type { TelegramAuthRequest, TelegramAuthRequestExtended } from '@/api';
import type { TelegramOAuthOptions } from '@/config';

import styles from './TelegramAuth.module.sass';

declare global {
  interface Window {
    Telegram: {
      Login: {
        auth: (options: TelegramOAuthOptions, callback: AuthCallback) => void;
      };
    };
    HelpCrunch: (action: string, data?: Record<string, string>) => void;
    google: {
      accounts: {
        id: any;
        name: string;
        email: string;
      };
    };
  }
}

type TelegramUserData = TelegramAuthRequest;

type AuthCallback = (user: TelegramUserData | false) => void;

interface TelegramAuthProps {
  gaCallback?: () => void;
  disabled?: boolean;
}

const TelegramAuth: FC<TelegramAuthProps> = (props) => {
  const { gaCallback, disabled = false } = props;
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const authFailedMessage = t('translation.auth_failed');

  const clickHandler = () => {
    try {
      window.Telegram.Login.auth(TELEGRAM_OAUTH_OPTIONS, (user) => {
        if (!user) {
          toast.error(authFailedMessage, {
            containerId: COMMON_CONTAINER_ID,
          });
        } else {
          const payload: TelegramAuthRequestExtended = {
            ...user,
            gaCallback,
          };

          dispatch(userActions.telegramAuth(payload));
        }
      });
    } catch (error: unknown) {
      console.log(error);
    }
  };

  return (
    <Button
      size="xl"
      type="shadow"
      corner="rect"
      className={styles.short}
      onClick={clickHandler}
      disabled={disabled}
    >
      <SvgIcon name="telegram" />
    </Button>
  );
};

export default TelegramAuth;
